/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserRole } from './UserRole';
import {
    UserRoleFromJSON,
    UserRoleFromJSONTyped,
    UserRoleToJSON,
} from './UserRole';
import type { VwbWorkspace } from './VwbWorkspace';
import {
    VwbWorkspaceFromJSON,
    VwbWorkspaceFromJSONTyped,
    VwbWorkspaceToJSON,
} from './VwbWorkspace';

/**
 * Admin-visible metadata about a VWB workspace.
 * @export
 * @interface VwbWorkspaceAdminView
 */
export interface VwbWorkspaceAdminView {
    /**
     * 
     * @type {VwbWorkspace}
     * @memberof VwbWorkspaceAdminView
     */
    workspace?: VwbWorkspace;
    /**
     * ID used in the AoU RWB workspace table. Useful for DB queries and Action Audit searches in Stackdriver Logging and BigQuery.
     * @type {number}
     * @memberof VwbWorkspaceAdminView
     */
    workspaceDatabaseId?: number;
    /**
     * List of users who own or collaborate on this workspace.
     * @type {Array<UserRole>}
     * @memberof VwbWorkspaceAdminView
     */
    collaborators?: Array<UserRole>;
}

/**
 * Check if a given object implements the VwbWorkspaceAdminView interface.
 */
export function instanceOfVwbWorkspaceAdminView(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VwbWorkspaceAdminViewFromJSON(json: any): VwbWorkspaceAdminView {
    return VwbWorkspaceAdminViewFromJSONTyped(json, false);
}

export function VwbWorkspaceAdminViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): VwbWorkspaceAdminView {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'workspace': !exists(json, 'workspace') ? undefined : VwbWorkspaceFromJSON(json['workspace']),
        'workspaceDatabaseId': !exists(json, 'workspaceDatabaseId') ? undefined : json['workspaceDatabaseId'],
        'collaborators': !exists(json, 'collaborators') ? undefined : ((json['collaborators'] as Array<any>).map(UserRoleFromJSON)),
    };
}

export function VwbWorkspaceAdminViewToJSON(value?: VwbWorkspaceAdminView | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'workspace': VwbWorkspaceToJSON(value.workspace),
        'workspaceDatabaseId': value.workspaceDatabaseId,
        'collaborators': value.collaborators === undefined ? undefined : ((value.collaborators as Array<any>).map(UserRoleToJSON)),
    };
}

